<template>
  <div class="formulate-input">
    <label
      class="formulate-input-label mb-2"
      :for="id"
    >
      <small
        v-show="isRequired"
        class="text-danger"
      >
        *
      </small>
      {{ labelText }}</label
    >
    <v-select
      v-model="localValue"
      :value="localValue"
      @input="updateLocalValue"
      :id="id"
      :label="labelOption"
      :options="orderAlphabetically(options)"
      :placeholder="placeholder"
      :multiple="multiple"
      :required="isRequired"
      :reduce="(item) => item.value"
    >
      <template v-slot:no-options>Nenhum item encontrado.</template>
    </v-select>
  </div>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'
export default {
  name: 'NxSelectReduced',
  mixins: [useReactiveModelMixin('value')],
  props: {
    options: {
      type: Array,
      required: true,
      default: null
    },
    labelOption: {
      type: String,
      required: false,
      default: 'text'
    },
    labelText: {
      type: String,
      required: false,
      default: 'Selecione:'
    },
    id: {
      type: String,
      required: true,
      default: null
    },
    placeholder: {
      type: String,
      required: true,
      default: null
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
    this.$root.$on('clearForm', () => {
      this.localValue = null
    })
  },
  methods: {
    orderAlphabetically (list) {
      let options = list

      return options.slice().sort((a, b) => a.text.localeCompare(b.text))
    },
    updateLocalValue (newValue) {
      this.localValue = newValue
    }
  }
}
</script>
<style lang="scss">
.formulate-input {
  li {
    text-transform: uppercase !important;
  }
}
.v-select.vs--open {
  .vs__dropdown-toggle {
    outline: 0;
    border: 1px solid #41b883;
  }
}

.v-select {
  .vs__dropdown-toggle {
    min-height: 2.2rem;
    padding: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/selects/NxSelectReduced.vue